import React from 'react';
import './NameInput.css';

export const NameInput = ({name, setName}) => {
    return (
        <>
            <h1 className={"extra_text"}>Oh, véritablement fascinant ! Aurais-je le privilège de découvrir votre prénom ?</h1>
            <input className={"input"} type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Prénom"/>
        </>
    )
}
